import * as React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
var Common_Shimmer = function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "common-shimmer ".concat(props.className ? props.className : "") },
            React.createElement(Skeleton, { className: "SkeletonTile h-40", count: props.number ? props.number : 4 }))));
};
export default Common_Shimmer;
